import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import widgetTypes from '../../components/widgetTypes';
import _ from 'lodash';

class WidgetTypeRouter extends Component {
  render() {
    const widgetType = _.find(widgetTypes, {id: this.props.widget.type});
    const WidgetComponent = widgetType && widgetType.component;

    if (WidgetComponent) {
      return <WidgetComponent {...this.props} />;
    } else {
      return <span>Unknown widget type</span>;
    }
  }
}

export default createFragmentContainer(
  WidgetTypeRouter,
  graphql`
    fragment WidgetTypeRouter_report on Report {
      ...withReportFilterProps_report
    }
    fragment WidgetTypeRouter_widget on Widget {
      id
      type
      ...withWidgetData_widget
    }
    fragment WidgetTypeRouter_surveys on SurveyConnection {
      ...withWidgetData_surveys
    }
    fragment WidgetTypeRouter_reports on ReportConnection {
      ...withWidgetData_reports
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/WidgetTypeRouter/WidgetTypeRouter.js